import React, { useState, useEffect } from "react";
import ListingBodyComponent from "../ListingBodyComponent/ListingBodyComponent";
import {
  fetchMyRolePlayList,
  fetchMyRolePlayListClear,
  fetchRolePlayMasterListUnAssigned,
  fetchRolePlayMasterListUnAssignedClear,
  reviewFilterList,
  reviewFilterListClear,
} from "../../../../redux/roleplay/actions";
import {
  getProcureInfo,
  ProductCardPriceInfo,
  SessionKeys,
} from "../../../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { RightArrowIcon } from "../../../../utils/SvgComps";
import CONFIG from "../../../../utils/config";

const RolePlayListingMainComponent = ({ isAll, isMyRolePlays, isToReview }) => {
  const [sortOption] = useState([
    { value: 1, label: "Name (A to Z)" },
    { value: 2, label: "Name (Z to A)" },
    { value: 3, label: "New To Old" },
    { value: 4, label: "Old To New" },
  ]);
  const [isLoading, setIsLoading] = useState(true);
  const [rpListing, setRPListing] = useState(CONFIG.INITIAL_PRODUCT_CARD_DATA);
  const [selectedSort, setSelectedSort] = useState(3);
  let dispatch = useDispatch();
  let navigate = useNavigate();

  const rpUnAssignedListing = useSelector(
    (state) => state.rolePlay.masterListUnassigned
  );

  const myRolePlayListResponse = useSelector(
    (state) => state.rolePlay.myRolePlayList
  );

  const reviewFilterListing = useSelector(
    (state) => state.rolePlay.reviewFilterList
  );

  useEffect(() => {
    setRPListing(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    setIsLoading(true);
    if (isAll) {
      fetchRolePlayListing();
    } else if (isMyRolePlays) {
      fetchMyRolePlayListing();
    } else if (isToReview) {
      fetchToReviewRolePlayListing();
    }
  }, [isAll, isMyRolePlays, isToReview, selectedSort]);

  const [pageSize, setPageSize] = useState(12);
  const [page, setPage] = useState(1);

  const fetchRolePlayListing = () => {
    dispatch(
      fetchRolePlayMasterListUnAssigned({
        module: "getRolePlayMasterList",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            : "",
          sort: selectedSort,
          page_size: pageSize,
          page: page,
        },
      })
    );
  };

  const fetchMyRolePlayListing = () => {
    dispatch(
      fetchMyRolePlayList({
        module: "myRolePlayList",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            : "",
          sort: selectedSort,
          page_size: 12,
          page: 1,
        },
      })
    );
  };

  const fetchToReviewRolePlayListing = () => {
    dispatch(
      reviewFilterList({
        module: "roleplayReviewList",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        },
      })
    );
  };

  useEffect(() => {
    console.log(rpUnAssignedListing);
    if (!_.isEmpty(rpUnAssignedListing)) {
      if (rpUnAssignedListing.status === "success") {
        const listingArr = rpUnAssignedListing.payload.payload?.List;

        if (_.isArray(listingArr) && !_.isEmpty(listingArr)) {
          formatRPForProductCart(listingArr);
        } else {
          setRPListing([]);
        }
      } else {
        setRPListing([]);
      }
      setIsLoading(false);
      dispatch(fetchRolePlayMasterListUnAssignedClear());
    }
  }, [rpUnAssignedListing]);

  useEffect(() => {
    if (!_.isEmpty(myRolePlayListResponse)) {
      if (myRolePlayListResponse.status === "success") {
        let listingArr = myRolePlayListResponse.payload.payload?.List;

        if (_.isArray(listingArr) && !_.isEmpty(listingArr)) {
          for (let i of listingArr) {
            i.api_type = "reviewe";
          }
          formatRPForProductCart(listingArr);
        } else {
          setRPListing([]);
        }
      } else {
        setRPListing([]);
      }
      setIsLoading(false);
      dispatch(fetchMyRolePlayListClear());
    }
  }, [myRolePlayListResponse]);

  useEffect(() => {
    if (!_.isEmpty(reviewFilterListing)) {
      console.log("reviewlist--", reviewFilterListing);
      if (reviewFilterListing?.status === "success") {
        let listingArr = reviewFilterListing?.payload?.payload;

        if (_.isArray(listingArr) && !_.isEmpty(listingArr)) {
          for (let i of listingArr) {
            i.api_type = "review";
          }
          console.log("api_type", listingArr);
          formatRPForProductCart(listingArr);
        } else {
          setRPListing([]);
        }
      } else {
        setRPListing([]);
      }
      setIsLoading(false);
      dispatch(reviewFilterListClear());
    }
  }, [reviewFilterListing]);

  const navigateToView = (rp, id) => {
    if (rp?.api_type === "review") {
      // let paramsReq = {
      //   title: rp?.title,
      //   id: id,
      //   logoURL: rp?.provider?.provider_img,
      //   logoAltText: "RP",
      //   description: rp.situation,
      //   videoURL: rp?.roleplay_url,
      //   instruction: rp?.situation,
      //   positive: rp?.roleplay_sentiment_positive,
      //   negative: rp?.roleplay_sentiment_negative,
      //   neutral: rp?.roleplay_sentiment_neutral,
      //   analytics: rp?.roleplay_wpm,
      //   duration: rp?.roleplay_duration,
      //   add_comments: rp?.additional_comment,
      //   status: rp?.status,
      //   feedback: rp?.feedback_data,
      // }
      // let jsonString = JSON.stringify(paramsReq);
      // let encodedUrl = btoa(jsonString);

      let url = `/learn/roleplay-review/detail/${id}?type=${rp?.api_type}`;
      if (rp?.api_type === "review") {
        url = url + `&submit_id=${rp?.submit_tbl_id}`;
      }
      navigate(url);

      // navigate(`/learn/roleplay/detail/${id}`);
    } else {
      let url = `/learn/roleplay/detail/${id}`;
      if (rp?.api_type) {
        url = url + `?api_type=${rp?.api_type}`;
      }
      navigate(url);
    }
  };

  const convertTimeFormat = (timeString) => {
    const [minutes, seconds] = timeString.split(":");
    return `${minutes}m ${seconds}s`;
  };

  const timeAndDateConverter = (date) => {
    let date1 = date.split(" ");
    let obj = {};
    obj.date = formatDate(date1[0]);
    return obj.date;
  };

  function formatDate(inputDate) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const dateObj = new Date(inputDate);
    const month = months[dateObj.getMonth()];
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();

    return `${month} ${day}, ${year}`;
  }

  const formatRPForProductCart = (listingArr) => {
    let rpArr = [];
    for (let rp of listingArr) {
      let tags = [];
      let footerTags = [];
      let logoURL = "";
      let btnTitle = "Explore";
      if (!_.isEmpty(rp.provider)) {
        tags.push(rp.provider.display_name);
        logoURL = rp.provider.provider_img;
      }

      tags.push("Role play");
      if (rp?.api_type === "review") {
        tags.push(rp?.uploaded_type === "audio" ? "Audio" : "Video");
        if (rp?.roleplay_duration) {
          let time = rp?.roleplay_duration;
          let parts = time.split(":");
          let minutes = parts[0];
          let seconds = parts[1];
          tags.push(`${minutes}m ${seconds}s`);
        }
      }
      // if (rp.roleplay_type) {
      //   footerTags.push(rp.roleplay_type);
      //   tags.push(_.capitalize(rp.roleplay_type));
      // }
      // if (rp?.api_type === "review") {
      //   tags.push(convertTimeFormat(rp?.roleplay_duration));
      // } else if (rp?.api_type === "reviewe") {
      //   tags.push(convertTimeFormat(rp?.recorded_duration));
      // }

      let priceInfo = getProcureInfo(rp.purchased_info);
      rp.priceInfo = priceInfo;

      rpArr.push({
        id: rp.id,
        is_like: rp?.is_like ? rp?.is_like : false,
        is_bookmark: rp?.is_bookmark ? rp?.is_bookmark : false,
        dbId: rp?.list_id,
        productType: rp?.roleplay_type,
        is_wishlist: rp?.is_addtowishlist,
        productOrigin: "xsel",
        title: rp.title,
        logoURL: logoURL,
        logoAltText: "RP",
        bannerURL: rp.cover_img_url,
        tagsArray: tags,
        description: rp.situation ? rp.situation : rp?.description,
        duration: "",
        showHeader: true,
        showProviderIcon: true,
        showLikeMenu: false,
        showSubmitAndReview:
          rp?.api_type === "review" &&
          rp?.api_type != "reviewe" &&
          rp?.submitted_to
            ? true
            : false,
        showSubmittedBy: rp?.api_type === "review" ? true : false,
        submittedBy: rp?.user_first_name + " " + rp?.user_last_name,
        submittedOn: timeAndDateConverter(rp?.submitted_on),
        showReviewedBy:
          rp?.api_type === "review" &&
          rp?.api_type != "reviewe" &&
          rp?.reviewed_by
            ? true
            : false,
        feedbackStatus:
          rp?.api_type === "review" && rp?.api_type != "reviewe"
            ? rp?.status === "feedback_received"
              ? true
              : false
            : false,
        reviewedBy: rp?.submitted_to,
        reviewedOn: timeAndDateConverter(rp?.reviewed_on),
        roleplayType: rp?.api_type,
        showProgres: true,
        showBody: true,
        showFooter: true,
        btnTitle: btnTitle,
        btnAction: () => navigateToView(rp, rp.id),
        descAction: () => navigateToView(rp, rp.id),
        bannerAction: () => navigateToView(rp, rp.id),
        cardClassName: "",
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        priceInfo,
        isLoading: false,
        rightBtnIcon: <RightArrowIcon />,
        leftBtnIcon: "",
        updatedAt: rp?.is_assigned?"":_.isEmpty(priceInfo)||priceInfo?.isFree || !priceInfo.isPurchased ? rp?.created_dt:"",
      });
    }
    setRPListing(rpArr);
  };

  return (
    <>
      <ListingBodyComponent
        categoryList={[]}
        selectedCatIds={[]}
        selectedSubCatIds={[]}
        subCatList={[]}
        checkBoxOnChange={() => {}}
        onSelectSubCat={() => {}}
        onSearchClicked={() => {}}
        // searchText={searchText}
        // setSearchText={setSearchText}
        placeHolderMsg={"Search for roleplay..."}
        showSearch={false}
        showSort={isAll ? true : false}
        showFilter={false}
        showCategories={false}
        sortOption={sortOption}
        filterOption={[]}
        sortSelected={selectedSort}
        setSelectedSort={setSelectedSort}
        isFetching={isLoading}
        setSelectedFilter={() => {}}
        onFilterClicked={() => {}}
        formattedListing={rpListing}
        type={"video"}
      />
    </>
  );
};

export default RolePlayListingMainComponent;
